import { apply, put } from 'redux-saga/effects';
import { errorNotification } from '../reducers/notification.reducers';
import {
  loadUiOptionsSucceeded,
  setAlertSoundState,
} from '../reducers/app.reducers';

// eslint-disable-next-line import/prefer-default-export
export function* loadUiOptions(appApi) {
  try {
    const response = yield apply(
      appApi,
      appApi.loadUiOptions,
    );

    if (response && response.locationName) {
      document.title = `Bestellungen - ${response.locationName}`;
    }

    if (response.errorCode || response.exceptionMessage) {
      yield put(errorNotification(response.message || 'Failed to load ui options'));
    } else {
      yield put(loadUiOptionsSucceeded(response));
    }

    yield put(setAlertSoundState(false))
  } catch (e) {
    yield put(errorNotification('Failed to load ui options'));
  }
}

export function* toggleFullScreen() {

  console.log(document.fullscreenElement)

  const element_root = document.documentElement;

  if ((window.fullScreen) || (window.innerWidth == window.screen.width && window.innerHeight == window.screen.height)) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  } else {
    if (element_root.requestFullscreen) {
      element_root.requestFullscreen();
    } else if (element_root.mozRequestFullScreen) { /* Firefox */
      element_root.mozRequestFullScreen();
    } else if (element_root.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      element_root.webkitRequestFullscreen();
    } else if (element_root.msRequestFullscreen) { /* IE/Edge */
      element_root.msRequestFullscreen();
    }
  }
}

